import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-congratulation-onboarding-dialog',
  templateUrl: './congratulation-onboarding-dialog.component.html',
})
export class CongratulationOnboardingDialogComponent {
  public title: string;
  public message: string;

  constructor(
    public dialogRef: MatDialogRef<CongratulationOnboardingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  public backToHome(): void {
    this.dialogRef.close('home');
  }

  public tryAnotherExample(): void {
    this.dialogRef.close('another');
  }
}

export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
  ) {}
}
